import api from "@/lib/api";
import log from "loglevel";

export interface PostTrialRequest {
  transactionId: string;
}

export interface PostTrialResponse {
  contractNumber: string;
}

export default {
  // 30日無料体験 登録API
  postFreeTrialRegister(data: any) {
    return api<PostTrialRequest, PostTrialResponse>({
      endpoint: "trial/web-api/freetrial",
      method: "POST",
      body: data
    });
  }
};
